import { motion, useInView } from 'framer-motion';
import { graphql, Link, useStaticQuery } from 'gatsby';
import parse from 'html-react-parser';
import React, { useEffect, useRef, useState } from 'react';
import { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import { Swiper, SwiperSlide } from 'swiper/react';
import ImageOpt from '../components/ImageOpt';
import Layout from '../components/Layout';
const NotFoundPage = (props) => {
  const handleNextClick = (selector) => {
    const swiper = document.querySelector(selector).swiper;
    swiper.slideNext();
  };
  const handlePrevClick = (selector) => {
    const swiper = document.querySelector(selector).swiper;
    swiper.slidePrev();
  };
  const ref = useRef(null);
  const isInView = useInView(ref);
  const [hasPlayed, setHasPlayed] = useState(false);

  const animationVariants = {
    hidden: {
      opacity: 0,
      y: 20,
    },
    visible: {
      opacity: 1,
      y: 0,
      delayChildren: 0.1,
      staggerChildren: 0.2,
    },
  };

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: 'easeOut',
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  };

  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeInOut',
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  };

  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true);
    }
  }, [isInView, hasPlayed, setHasPlayed]);

  const fourData = useStaticQuery(graphql`
    query {
      wp {
        fluxDnaSettings {
          fluxDna {
            fourHeading
            fourDescription
            fourImage {
              altText
              mediaItemUrl
            }
            callImage {
              altText
              mediaItemUrl
            }
            callHeading
            callDescription
            callBook {
              target
              title
              url
            }
            relatedCardsHeading
            relatedCardsSubHeading
            relatedCardsDescription
            selectRelatedCards
            cards {
              link {
                target
                title
                url
              }
              title
              cardType
              description
              image {
                altText
                mediaItemUrl
                publicUrl
              }
            }
          }
        }
      }
    }
  `);
  const fourDataList = fourData.wp.fluxDnaSettings.fluxDna;
  const selectCards = fourDataList.selectRelatedCards;
  return (
    <div className="fullPageanimation">
      <Layout props={props}>
        <section className="banner small-banner">
          <div className="desk-img h-full relative">
            {fourDataList?.fourImage && (
              <ImageOpt
                imgData={fourDataList.fourImage.mediaItemUrl}
                imgAlt={fourDataList.fourImage.altText}
                imgLoad="eager"
                imgClass="w-full h-full object-cover"
                width={1440}
                height={829}
              />
            )}
          </div>
          <div className="banner-content absolute !left-50per !pb-150 lgscreen:!pb-50 translate-x-minus_50 text-center z-9 w-[790px] lgscreen:w-full lgscreen:px-20 mx-auto">
            {fourDataList?.fourHeading && (
              <motion.h1
              initial="hidden"
              animate="visible"
              variants={animationVariants}
              transition={{ duration: 0.5 }}
               className="text-white py-15 text-[100px] lgscreen:text-[60px] mb-30 lgscreen:mb-15">
                {' '}
                {fourDataList.fourHeading}
              </motion.h1>
            )}
            {fourDataList?.fourDescription && (
              <motion.div
              initial="hidden"
              animate="visible"
              variants={animationVariants}
              transition={{ duration: 0.5, delay: 0.5 }}>
              <p className="text-white text-[22px] leading-[32px] lgscreen:text-16 lgscreen:leading-[22px] font-heading italic font-500">
                {fourDataList.fourDescription}
              </p>
              </motion.div>
            )}
            <motion.div
              initial="hidden"
              animate="visible"
              variants={animationVariants}
              transition={{ duration: 0.5, delay: 1 }}
               className="btn-custom  mt-30">
              <Link to="/" className="btn btn-transparent inline-block">
                go to home
              </Link>
            </motion.div>
          </div>
        </section>
      </Layout>
    </div>
  );
};

export default NotFoundPage;

export const Head = () => <title>404 | Mdluli Safari Lodge</title>;
